// extracted by mini-css-extract-plugin
module.exports = {"imageContent":"styles_imageContent__0S6pI","imageContent__image":"styles_imageContent__image__qzKQf","imageContent__caption":"styles_imageContent__caption__zh01L"};